import { render, staticRenderFns } from "./404.vue?vue&type=template&id=da5bf046&scoped=true&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=da5bf046&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5bf046",
  null
  
)

export default component.exports